import React, { useState } from "react";
import backarrow from "../../../assets/images/back-arrow-left.svg";
import useExpressShieldFlow from "../../../hooks/BuyOnlineExpressShield/useExpressShieldFlow";
import LifeInsuranceBottomStickyBtnLayout from "../../motorInsurancePages/newMotorPolicy/Layouts/LifeInsuranceBottomStickyLayout";
import LifeViewSummaryPopup from "../../../components/newMotorPolicy/veiwSummaryPopup/lifeViewSummaryPopup";
import { useSelector } from "react-redux";
import { selectExpressShieldData } from "../../../redux/features/expressSheild/expressSheildSlice";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const ExpressShieldPlanLayout = ({
  children,
  is_hide_back_btn,
  show_close_btn,
  btn_label,
  btn_onClick,
  btn_disabled,
  show_summary,
  is_bottom_sticky_layout = true,
  isLoading

}) => {
  const { handlePrevSubstep } = useExpressShieldFlow();
  const translate = useLanguageTranslate();
  const [show, setShow] = useState(false)
  const showSummaryHandler = () => {
    setShow(true)
  }

  const expressSheildData = useSelector(selectExpressShieldData);
  let totalAmount = expressSheildData?.TotalPremium ||0

  // Each step renders its own layout, so this wrapper is a fresh element on
  // every advance and the entrance plays once per step. It wraps the page
  // content only, never the footer: a transform on an ancestor would become
  // the containing block for the fixed footer and drag it along mid-slide.
  const step = (
    <div data-claim-step className="animate-claimStepIn">
      {children}
    </div>
  );

  return (
    <div className=" ">
      <div className="summarypopup">
        <LifeViewSummaryPopup
          TotalPremium={expressSheildData?.TotalPremium || 0}
          Tax={expressSheildData?.Tax}
          Premium={expressSheildData?.Premium || 0}
          QuoteNumber={expressSheildData?.QuoteDetails?.QuoteNumber || ""}
          show={show}
          setShow={setShow}
        />
      </div>
      {/* On mobile Back sits in the header row, pinned top-left opposite the
          header's own Close (same 40px, same 16px inset), rather than in the
          page flow where the fixed header and progress bar covered it. The
          Close this layout used to add on mobile is gone: it sat under the
          header too, and the header's Close already goes to /new-policy. */}
      {!is_hide_back_btn && (
        <button
          className="backButton bg-navy-blue py-2 rounded mt-20 flex absolute left-[26px] rtl:right-[26px] top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px] max767:bg-[#F6F8F9] max767:w-10 max767:h-10 max767:text-center max767:justify-center max767:items-center max767:rounded-3xl max767:fixed max767:top-[19px] max767:left-4 max767:rtl:left-auto max767:rtl:right-4 max767:mt-0 max767:py-0 max767:z-30 max767:transition-transform max767:duration-150 max767:ease-out max767:active:scale-[0.94]"
          onClick={handlePrevSubstep}
        >
          <img
            src={backarrow}
            alt="Back arrow"
            className="1 rtl:ml-[5px] rtl:rotate-[180deg]"
          />
          <span className="back-text inline max767:hidden">
            {translate("Back", "رجوع")}
          </span>
        </button>
      )}
      {/* Always this layout, with the footer hidden rather than the layout
          swapped out: the pages turn is_bottom_sticky_layout off while a popup
          is open, and swapping the parent remounted the step, replaying its
          slide-in and carrying the popup (fixed, but inside the transformed
          step) sideways with it. */}
      <LifeInsuranceBottomStickyBtnLayout
        hide_footer={!is_bottom_sticky_layout}
        show_summary={show_summary}
        btn_onClick={btn_onClick}
        btn_disabled={btn_disabled}
        btn_label={btn_label}
        isLoading={isLoading}
        showSummaryHandler={showSummaryHandler}
        totalAmount={totalAmount}
      >
        {step}
      </LifeInsuranceBottomStickyBtnLayout>
    </div>
  );
};

export default ExpressShieldPlanLayout;
